import Quill from 'quill/core';
import { useEffect, useState } from 'react';
import isPostContentEmpty from './isPostContentEmpty';
import useAppSelector from '../../app/redux/useAppSelector';
import { useQuill, useQuillReadOnly } from '../../editor/QuillContext';

const useShouldShowEditorPlaceholder = () => {
  const readOnly = useQuillReadOnly();
  const isNewPost = useAppSelector((state) => state.editor.version === 0);
  const initialContent = useAppSelector((state) => state.editor.initialContent);
  const isPlaceholderAllowed =
    !readOnly && isNewPost && isPostContentEmpty(initialContent);

  const { quill } = useQuill();
  const [hasContentChanged, setHasContentChanged] = useState(false);

  const shouldSkip = hasContentChanged || !isPlaceholderAllowed;
  useEffect(() => {
    if (!quill || shouldSkip) return undefined;

    const handler = () => {
      setHasContentChanged(true);
    };

    quill.once(Quill.events.TEXT_CHANGE, handler);
    return () => {
      quill.off(Quill.events.TEXT_CHANGE, handler);
    };
  }, [quill, shouldSkip]);

  return isPlaceholderAllowed && !hasContentChanged;
};

export default useShouldShowEditorPlaceholder;
